import { IonContent, IonInput, IonPage, IonText,IonIcon,IonSpinner } from "@ionic/react"
import { useEffect, useState ,useMemo} from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import Select from "react-select"
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert'
import {searchOutline , chevronDownOutline } from "ionicons/icons";

const HRDepartmentunit: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
          history.push("/login");
        } else {
        }
      }, [Id, history]);
    const [data, setData]: any = useState([]);

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);

    const [id, setId] = useState("");

    const [businessName, setBusinessName] = useState([]);
    const [employeelist, setEmployeelist] = useState([]);
    const[loading,setloading]=useState(false)
    /*............ Create ............ */

    const [Bname, setBname] = useState("");
    const [Dcode, setDcode] = useState("");
    const [Dname, setDname] = useState("");
    const [Dhead, setDhead] = useState("");
    const [Dalter, setDalter] = useState("");

    /*............. View & Update........ */

    const [DepartName, setDepartName] = useState("");
    const [DepartCode, setDepartCode] = useState("");
    const [Departhead, setDeparthead] = useState("");
    const [Departalter, setDepartalter] = useState("");

 /*................... Businessunit Auto complete .................. */

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{color:"black"}}>Select Business Unit</span>;
        } else {
            return <span style={{color:"black"}}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);
      
        useEffect(() => {
          if (isClicked && !selectProps.menuIsOpen1) {
            setIsClicked(false);
          }
        }, [selectProps.menuIsOpen1]);
      
        let icon;
        if (isClicked || selectProps.menuIsOpen) {
          icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
          icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }
      
        const handleIconClick = () => {
          setIsClicked(true);
        };
      
        return (
          <div {...innerProps}>
            <div onClick={handleIconClick}>{icon}</div>
          </div>
        );
      };
        const options = [

            ...businessName.map((state: any) => ({
                value: state.id,
                label: state.businessUnitName,
            })),
          
        ];
        const handleBusinessChange = (selectedOption: any) => {
            setBname(selectedOption.value)  
        };

 /*................... Departmenthead Auto complete .................. */

        const [selectedOption1, setSelectedOption1] = useState(null);
        const [inputValue1, setInputValue1] = useState('');
        const [isFocused1, setIsFocused1] = useState(false);
        const [menuIsOpen1, setMenuIsOpen1] = useState(false);
    
        const handleStateChange1 = (selectedOption1: any) => {
            setSelectedOption1(selectedOption1);
        };
    
        const handleInputChange1 = (inputValue1: any) => {
            setInputValue1(inputValue1);
        };
    
        const handleMenuOpen1 = () => {
            setMenuIsOpen1(true);
        };
    
        const handleMenuClose1 = () => {
            setMenuIsOpen1(false);
        };
    
        const handleFocus1 = () => {
            setIsFocused1(true);
        };
    
        const handleBlur1 = () => {
            setIsFocused1(false);
        };
    
        const Placeholder1 = () => {
            if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
                return <span style={{color:"black"}}>Select Department Head</span>;
            } else {
                return <span style={{color:"black"}}>Type to Search Here...</span>;
            }
        };
    
        const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
            const [isClicked, setIsClicked] = useState(false);
         
            useEffect(() => {
              if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
              }
            }, [selectProps.menuIsOpen]);
         
            let icon
            if (isClicked || selectProps.menuIsOpen) {
              icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
            } else {
              icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
            }
         
            const handleIconClick = () => {
              setIsClicked(true);
            };
         
            return (
              <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
              </div>
            );
          };
            const option1 = [
                ...employeelist.map((state: any) => ({
                    value: state.id,
                    label: state.name,
                })),
            ];
            const handleDeptheadChange = (selectedOption1: any) => {
                setDhead(selectedOption1.value)
                
            };

             /*................... Depthead update Auto complete .................. */


            const handleDeptUpdateChange = (selectedOption1: any) => {
                setDeparthead(selectedOption1.value)
                
            };

 /*................... Departmenthead Auto complete .................. */

            const [selectedOption2, setSelectedOption2] = useState(null);
        const [inputValue2, setInputValue2] = useState('');
        const [isFocused2, setIsFocused2] = useState(false);
        const [menuIsOpen2, setMenuIsOpen2] = useState(false);
    
        const handleStateChange2 = (selectedOption2: any) => {
            setSelectedOption2(selectedOption2);
        };
    
        const handleInputChange2 = (inputValue2: any) => {
            setInputValue2(inputValue2);
        };
    
        const handleMenuOpen2 = () => {
            setMenuIsOpen2(true);
        };
    
        const handleMenuClose2 = () => {
            setMenuIsOpen2(false);
        };
    
        const handleFocus2 = () => {
            setIsFocused2(true);
        };
    
        const handleBlur2 = () => {
            setIsFocused2(false);
        };
    
        const Placeholder2 = () => {
            if (inputValue2 === '' && !selectedOption2 && !isFocused2) {
                return <span style={{color:"black"}}>Select Department Head</span>;
            } else {
                return <span style={{color:"black"}}>Type to Search Here...</span>;
            }
        };
    
        const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
            const [isClicked, setIsClicked] = useState(false);
         
            useEffect(() => {
              if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
              }
            }, [selectProps.menuIsOpen]);
         
            let icon
            if (isClicked || selectProps.menuIsOpen) {
              icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
            } else {
              icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
            }
         
            const handleIconClick = () => {
              setIsClicked(true);
            };
         
            return (
              <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
              </div>
            );
          };
          
            const option2 = [
    
                ...employeelist.map((state: any) => ({
                    value: state.id,
                    label: state.name,
                })),
              
            ];
            const handleDeptAlterUpdate = (selectedOption2: any) => {
                setDepartalter(selectedOption2.value)
                
            };

             /*................... Department alter Auto complete .................. */

        
            const handleDeptAlterChange = (selectedOption2: any) => {
                setDalter(selectedOption2.value)
                
            };

//.....................Getall Api..................//

    useEffect(() => {
        LoadDepart();
        ViewAllBusinessName();
        LoadEmployeeList();
    }, [])

    const LoadDepart = () => {
        setloading(true);
        service.GetallMasterDepartment()
            .then((response) => {
                console.log(response);
                console.log("RESPONSE", response.data.Data);
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    };
//......................Getall employee Api..............//

    const LoadEmployeeList = () => {
        service.GetAllEmployeeNameDropDown()
            .then((response) => {
                console.log("All Employee Names")
                console.log(response);
                if (response.data === null || response.data.Data === null) {
                    setEmployeelist([])
                }
                else {
                    setEmployeelist(response.data.Data);
                }
            })
    }

//...................Getall businessunit Api..................//

    const ViewAllBusinessName = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessName(response.data.Data)
                }
                else {
                    setBusinessName([])
                }
            })
    }

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

//.......................Departmentunit Datatable .........................//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "70px"
        },
        {
            name: "Dept Code",
            selector: (itm: any) => itm.departmentCode,
            sortable: true,
            width: "150px",
        },
        {
            name: "Dept Name",
            selector: (itm: any) => itm.departmentName,
            sortable: true,
            width: "150px"
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnitId,
            sortable: true,
            width:"150px"
        },
        {
            name: "Dept Head",
            selector: (itm: any) => itm.departmentHead,
            sortable: true,
            width:"250px"
        },
        {
            name: "Dept Alternate",
            selector: (itm: any) => itm.departmentAlternate,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "150px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )

        }
    ]
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    //...............Search filter....................//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        
        };
    
    return (
        <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
                <div className="form-group form-focus row">
                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                        value={filterText} placeholder="Search" />
                    <label className="focus-label">Search</label>
                </div>
                <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
            </div>
        </div>
    )
    
    }, [filterText, resetPaginationToggle]);

//...............Department modal.....................//

    const openmodal = (id: any) => {
        setId(id)
        setModalopen(true);
        service.ViewDepartmentUnitById(id)
            .then((response) => {
                console.log(response);
                console.log("RESPONSE", response.data.Data);
                if (response.data.Data.departmentName === null || response.data.Data.departmentName === "") {
                    setDepartName("");
                }
                else {
                    setDepartName(response.data.Data.departmentName)
                }
                if (response.data.Data.departmentCode === null || response.data.Data.departmentCode === "") {
                    setDepartCode("");
                }
                else {
                    setDepartCode(response.data.Data.departmentCode)
                }
                if (response.data.Data.departmentHead === null || response.data.Data.departmentHead === "") {
                    setDeparthead("");
                }
                else {
                    setDeparthead(response.data.Data.departmentHead)
                }
                if (response.data.Data.departmentAlternate === null || response.data.Data.departmentAlternate === "") {
                    setDepartalter("");
                }
                else {
                    setDepartalter(response.data.Data.departmentAlternate)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    const closemodal = () => {
        setModalopen(false);
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setBname("");
        setDcode("");
        setDname("");
        setDhead("");
        setDalter("");
    }

//.....................Create departmentunit....................//

    const Create = () => {
        if (Bname.length === 0) {
            swal("", "Please Select BU Name", "info")
        }
        else if (Dcode.length === 0) {
            swal("", "Please Enter Department Code", "info")
            return;
        }
        else if (Dname.length === 0) {
            swal("", "Please Enter Department Name", "info")
            return;
        }
        // else if (Dhead.length === 0) {
        //     swal("", "Please Select Department Head", "info")
        //     return;
        // }
        // else if (Dalter.length === 0) {
        //     swal("", "Please Enter Business Alternate", "info")
        //     return;
        // }
        else {
            service.CreateDepartmentUnit(Dname, Dcode, Dhead, Dalter, Bname)
                .then((response) => {
                    console.log("resss", response);
                    if (response.data.Status === "200") {
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    } else {
                        swal("", response.data.Message, "error")
                    }
                })
        }
    }

//......................Update departmentunit........................//

    const Update = () => {
        service.UpdateDepartmentUnit(id, DepartName, DepartCode, Departhead, Departalter)
            .then((response) => {
                if (response.data.Status === '200') {
                    swal("", "Updated Sucessfully", "success")
                    window.location.reload();
                } else {
                    swal("",response.data.Message,"info")
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleCreateBusinessName = (e: any) => {
        setBname(e.target.value);
    }

    const handleCreateHead = (e: any) => {
        setDhead(e.target.value);
    }

    const handleCreateHeadAlter = (e: any) => {
        setDalter(e.target.value)
    }

    const handleHead = (e: any) => {
        setDeparthead(e.target.value);
    }

    const handleHeadAlter = (e: any) => {
        setDepartalter(e.target.value);
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>Department Unit</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Department Unit</a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>

{/*...................View Departmentunit..................*/}

                    <Modal
                     dialogClassName="modal-dialog modal-lg"
                        // id="logouts-modal"
                        show={modalopen}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Department Unit</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Code <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={DepartCode} onIonChange={(e: any) => setDepartCode(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={DepartName} onIonChange={(e: any) => setDepartName(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Head <span className="text-danger">*</span></label>
                                    <div>
                                    <Select 
                                            
                                            options={option1}
                                            value={option1.find((option) => option.value === Departhead) || null}
                                            onChange={handleDeptUpdateChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                         
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholder1 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator1,
                                            }}
                                              className="custom-select6"
                                        />
                                        {/* <select value={Departhead} className="select" onChange={(e: any) => handleHead(e)}>
                                            <option value="" disabled selected>Select Head</option>
                                            {employeelist.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select> */}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Alternate - Assignment <span className="text-danger">*</span></label>
                                    <div>
                                    <Select 
                                            
                                            options={option2}
                                            value={option2.find((option) => option.value === Departalter) || null}
                                            onChange={handleDeptAlterUpdate}
                                            onInputChange={handleInputChange2}
                                            onMenuOpen={handleMenuOpen2}
                                            onMenuClose={handleMenuClose2}
                                            onFocus={handleFocus2}
                                            onBlur={handleBlur2}
                                            menuIsOpen={menuIsOpen2}
                                            isSearchable
                                            placeholder={<Placeholder2 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator2,
                                            }}
                                              className="custom-select5"
                                        />
                                        {/* <select value={Departalter} className="select" onChange={(e: any) => handleHeadAlter(e)}>
                                            <option value="" disabled selected>Select Alternate - Assignment</option>
                                            {employeelist.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select> */}
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                </div>
                            </form>
                        </div>
                    </Modal>

                   {/*....................Create Modal..............*/}

                    <Modal
                     dialogClassName="modal-dialog modal-lg"
                        // id="logouts-modal"
                        show={modalopen1}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Create Department Unit</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Name <span className="text-danger">*</span></label>
                                    <div>
                                    <Select 
                                            
                                            options={options}
                                            value={options.find((option) => option.value === Bname) || null}
                                            onChange={handleBusinessChange}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable
                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                              className="custom-select6"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Code <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={Dcode} placeholder="Ex: IT TECH - 1" onIonChange={(e: any) => setDcode(e.detail.value)} className="form-control" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={Dname} onIonChange={(e: any) => setDname(e.detail.value)} className="form-control" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Head </label>
                                    <div>
                                    <Select 
                                            
                                            options={option1}
                                            value={option1.find((option) => option.value === Dhead) || null}
                                            onChange={handleDeptheadChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholder1 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator1,
                                            }}
                                              className="custom-select6"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Depart Alternate - Assignmemt </label>
                                    <div>
                                    <Select 
                                            
                                            options={option2}
                                            value={option2.find((option) => option.value === Dalter) || null}
                                            onChange={handleDeptAlterChange}
                                            onInputChange={handleInputChange2}
                                            onMenuOpen={handleMenuOpen2}
                                            onMenuClose={handleMenuClose2}
                                            onFocus={handleFocus2}
                                            onBlur={handleBlur2}
                                            menuIsOpen={menuIsOpen2}
                                            isSearchable
                                            placeholder={<Placeholder2 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator2,
                                            }}
                                              className="custom-select5"
                                        />
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                                </div>
                            </form>
                        </div>
                    </Modal>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default HRDepartmentunit